<template>
  <div class="learning-home-page" v-loading="loading">

    <el-card shadow="never" class="overview-card" v-if="overview && Object.keys(overview).length > 0">

      <div class="unlearned-tip" style="text-align: center; font-size: 18px; margin-bottom: 25px; color: #303133;">
        还有 <span class="highlight" style="color: #F56C6C;">{{ unlearnedQuestionCount }}</span> 题没有练习------还有 <span class="highlight" style="color: #F56C6C;">{{ wrongCount }}</span> 题没有纠错
      </div>

      <div class="overview-metrics">
        <div class="metric-item">
          <div class="metric-title">学习覆盖率</div>
          <el-progress type="dashboard" :percentage="overview.coverageRate || 0" color="#409EFF" :width="130"></el-progress>
          <div class="metric-value">{{ overview.learnedQuestionCount || 0 }} / {{ overview.totalQuestionCount || 0 }} 题</div>
        </div>

        <div class="metric-item">
          <div class="metric-title">初始掌握率</div>
          <el-progress type="dashboard" :percentage="overview.initialMasteryRate || 0" color="#67C23A" :width="130"></el-progress>
          <div class="metric-extra">反映首次答对比例</div>
        </div>

        <div class="metric-item">
          <div class="metric-title">错题待纠正</div>
          <div class="wrong-circle">
            <span class="wrong-num">{{ overview.currentWrongCount || 0 }}</span>
          </div>
          <div class="metric-extra" style="color: #F56C6C;">请尽快重做错题</div>
        </div>
      </div>
    </el-card>

    <div class="guide-hint-line">
      <div class="hint-item">
        <span class="hint-text">1、先练题</span>
        <span class="long-arrow-text">→→→→</span>
      </div>
      <div class="hint-item">
        <span class="hint-text">2、再纠错</span>
        <span class="long-arrow-text">→→→→</span>
      </div>
      <div class="hint-item">
        <span class="hint-text">3、最后模拟考试</span>
      </div>
    </div>

    <div class="nav-entry-container">
      <el-card shadow="hover" class="nav-card" @click.native="goTo('/student/practice/session/list')">
        <i class="el-icon-edit-outline nav-icon" style="color: #409EFF;"></i>
        <div class="nav-title">点击进入练题</div>
        <div class="nav-desc">按题库、题型专项突破</div>
      </el-card>

      <el-card shadow="hover" class="nav-card" @click.native="goTo('/student/wrong-list')">
        <i class="el-icon-warning-outline nav-icon" style="color: #F56C6C;"></i>
        <div class="nav-title">点击进入错题本</div>
        <div class="nav-desc">消灭盲区，查漏补缺</div>
      </el-card>

      <el-card shadow="hover" class="nav-card" @click.native="goTo('/student/exam/list')">
        <i class="el-icon-document nav-icon" style="color: #67C23A;"></i>
        <div class="nav-title">点击进入模拟考试</div>
        <div class="nav-desc">全真环境，考前冲刺</div>
      </el-card>
    </div>

  </div>
</template>

<script>
import { getStudentHomeOverview } from '@/api/student/home'
import { reportOnlineStatus } from '@/api/student/onlineStatus'

export default {
  name: 'StudentHome',
  data() {
    return { loading: false, overview: {} }
  },
  computed: {
    unlearnedQuestionCount() {
      const total = this.overview.totalQuestionCount || 0
      const learned = this.overview.learnedQuestionCount || 0
      return Math.max(total - learned, 0)
    },
    wrongCount() {
      return this.overview.currentWrongCount || 0
    }
  },
  created() {
    this.loadData()
    this.reportHomeStatus()
  },
  methods: {
    async reportHomeStatus() {
      try {
        await reportOnlineStatus('IDLE')
      } catch (e) {
        console.log('上报在线状态失败', e)
      }
    },
    async loadData() {
      this.loading = true
      try {
        const res = await getStudentHomeOverview()
        if (res.code === 200) {
          this.overview = res.data || {}
        }
      } catch (e) {
        this.$message.error('加载学习数据失败')
      } finally {
        this.loading = false
      }
    },
    goTo(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
/* 概览卡片样式 */
.overview-card { margin-bottom: 30px; border-radius: 12px; }
.overview-header { display: flex; justify-content: space-between; align-items: center; }
.unlearned-tip { font-size: 15px; color: #606266; }
.highlight { font-size: 18px; font-weight: bold; margin: 0 4px; }
.overview-metrics { display: flex; justify-content: space-around; align-items: center; padding: 10px 0; }
.metric-item { text-align: center; }
.metric-title { font-size: 16px; font-weight: bold; color: #303133; margin-bottom: 20px; }
.metric-value, .metric-extra { margin-top: 15px; font-size: 14px; color: #909399; }
.wrong-circle { width: 130px; height: 130px; border-radius: 50%; border: 6px solid #F56C6C; display: flex; align-items: center; justify-content: center; margin: 0 auto; box-sizing: border-box; }
.wrong-num { font-size: 32px; color: #F56C6C; font-weight: bold; }

/* ✨ 指引文字行样式 ✨ */
.guide-hint-line {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 与下方按钮容器列数一致 */
  gap: 30px; /* 与下方按钮容器间距一致 */
  margin: 20px 0 30px 0;
  color: #F56C6C; /* 红色 */
  font-weight: bold;
  font-size: 42px;
}
.hint-item {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.long-arrow-text {
  position: absolute;
  left: calc(50% + 100px); /* 让箭头从文字中心偏右一点开始 */
  white-space: nowrap;
  letter-spacing: -2px; /* 让连字符更紧密，看起来像实线 */
}

/* 快捷入口卡片样式 */
.nav-entry-container { display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px; }
.nav-card { cursor: pointer; text-align: center; padding: 50px 20px; border-radius: 12px; transition: all 0.3s; }
.nav-card:hover { transform: translateY(-8px); box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1) !important; }
.nav-icon { display: block; font-size: 72px; margin-bottom: 24px; }
.nav-title { font-size: 24px; font-weight: bold; color: #303133; margin-bottom: 12px; }
.nav-desc { font-size: 14px; color: #909399; }
</style>